
import  axios  from 'axios';
import {getSingleUser, loadSingleUserDataInStore} from "../user/actions";
import {loadCompanysDataWithUserId} from "../company";
import {CLEAR_A_TOWJOB_ERROR_MESSAGE, clearTowErrorMsgInStore, loadTowjobDataInStore} from "../towjob/actions";
import AppUtils from "../../../utils/AppUtils";
import {loadFaxDataInStore} from "../fax/actions";


export const LOAD_STORAGELOT_DATA = 'storagelot/LOAD_STORAGELOT_DATA';
export const DELETE_A_STORAGELOT = 'storagelot/DELETE_A_STORAGELOT';
export const SAVE_A_STORAGELOT = 'storagelot/SAVE_A_STORAGELOT';
export const UPDATE_A_STORAGELOT = 'storagelot/UPDATE_A_STORAGELOT';
export const CLEAR_A_STORAGELOT_ERROR_MESSAGE = 'storagelot/CLEAR_A_STORAGELOT_ERROR_MESSAGE';


export function clearStoragelotErrorMsgInStore(){
    return {
        type: CLEAR_A_STORAGELOT_ERROR_MESSAGE,
        
    }
}

export function loadStoragelotDataInStore(argStoragelotDataArray) {
    return {
        type: LOAD_STORAGELOT_DATA,
        storagelotsData:argStoragelotDataArray
    }
}
export function deleteAStoragelotInStore(argDeleteResponse, argErrorMsg) {
    return {
        type: DELETE_A_STORAGELOT,
        deleteStoragelotResponse:argDeleteResponse,
        errorMsg:argErrorMsg
    }
}

export function saveAStoragelotDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: SAVE_A_STORAGELOT,
        saveStoragelotResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

export function updateAStoragelotDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: UPDATE_A_STORAGELOT,
        updateStoragelotResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}





//****************************************
//Below is for update a Stream
//****************************************

export function clearStoragelotErrorMsg(){
    return (dispatch, getState) => {
        dispatch(clearStoragelotErrorMsgInStore());
    }
}

export function updateAStoragelot(argURL, argCamera, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        updateAStoragelotOnServer(argURL, argCamera, argCompanyId ,state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(updateAStoragelotDataInStore(saveResponse.data, {"status":saveResponse.status, "statusText":saveResponse.statusText}));
            dispatch(loadStoragelotsData(argURL,  argCompanyId ));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            console.log("I had an error saving a storagelot" + errorObj.statusText + errorObj.status);
            dispatch(updateAStoragelotDataInStore({}, errorObj));
        });
    }//end of return
}


function updateAStoragelotOnServer( argURL, argCamera, argCompanyId ,argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPutsForUpdateAStoragelot(argURL, argCamera, argCompanyId ,argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                //console.log("Farshid some error occured on saving a StorageLot " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPutsForUpdateAStoragelot(argURL, argStoragelot,argCompanyId ,argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/companys
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/storagelots" ;
    console.log(" on posting a storagelot the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.put(baseUrl,argStoragelot, {headers: {"Authorization" : `Bearer ${argIdToken}`}} ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for save a Stream
//****************************************
export function saveAStoragelot(argURL, argCamera,argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        saveAStoragelotOnServer(argURL, argCamera,argCompanyId , state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(saveAStoragelotDataInStore(saveResponse.data, {"status":saveResponse.status, "statusText":saveResponse.statusText}));
            dispatch(loadStoragelotsData(argURL,  argCompanyId ));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
           console.log("I had an error saving a storage lot" + + errorObj.statusText + errorObj.status);
            dispatch(saveAStoragelotDataInStore({}, errorObj));
        });
    }//end of return
}


function saveAStoragelotOnServer( argURL, argCamera, argCompanyId  ,argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPostsForSaveAStoragelot(argURL, argCamera, argCompanyId  ,argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                //console.log("Farshid some error occured on saving a storagelot " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPostsForSaveAStoragelot(argURL, argCamera, argCompanyId ,argIdToken, argUserId){
    /*
     I build something like this :
     http://localhost:4567/companys
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/storagelots";
    console.log(" on posting a storagelot the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.post(baseUrl,argCamera ,{headers: {"Authorization" : `Bearer ${argIdToken}`}} ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for delete a company
//****************************************
export function deleteAStoragelot(argURL, argCameraId, argCompanyId ) {
    return (dispatch, getState) => {
        const state = getState();
        deleteAStoragelotOnServer(argURL, argCameraId,argCompanyId , state.login.loginData.idToken, state.user.saveUserResp.id).then(function(deleteResponse){
            //dispatch(loadStoragelotsData(argURL, argCompanyId));
            dispatch(deleteAStoragelotInStore(deleteResponse.data, {"status":deleteResponse.status, "statusText":deleteResponse.statusText}));
            dispatch(loadStoragelotsData(argURL,  argCameraId ));
           
        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            //console.log("I had an error gettting Stream Data2" + err);
            dispatch(deleteAStoragelotInStore({}, errorObj));
        });
    }//end of return
}


function deleteAStoragelotOnServer( argURL, argStreamId,argCompanyId,  argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){



        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfDeletesForDeleteAStoragelot(argURL, argStreamId, argCompanyId , argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                console.log("Farshid some error occured on deleteing a Storagelot " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfDeletesForDeleteAStoragelot(argURL, argRealCompanyId, argStorageId, argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/cameras
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies"+"/"+argRealCompanyId+"/storagelots/"+argStorageId;
    console.log(" on deleteing a Storagelot the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.delete(baseUrl, {headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}


//Get list of companys
/*
export function loadStoragelotsData(argURL, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        getListOfStoragelots(argURL, argCompanyId, state.login.loginData.idToken, state.user.saveUserResp.id).then(function(companysList){

            dispatch(loadStoragelotDataInStore(companysList));

    }, function(err){
        console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}
*/

export function loadStoragelotsData(argURL, argCompanyId) {
    if((argCompanyId !== null)&&( argCompanyId !== undefined)) {
        return (dispatch, getState) => {
            const state = getState();
            
            if ((state.user.saveUserResp === null) || (state.user.saveUserResp.id === null) || (state.user.saveUserResp.id === undefined)) {
                getSingleUser(argURL, state.login.loginData.idToken).then(function (userData) {
                    
                    // dispatch(loadTowjobDataInStore(companysList));
                    dispatch(loadSingleUserDataInStore(userData));
                    dispatch(loadCompanysDataWithUserId(argURL, userData.id));
                    
                    //getListOfStoragelots(argURL, state.company.selectedCompany, state.login.loginData.idToken, userData.id).then(function(companysList){
                    getListOfStoragelots(argURL, argCompanyId, state.login.loginData.idToken, userData.id).then(function (companysList) {
                        
                        dispatch(loadStoragelotDataInStore(companysList));
                        
                    }, function (err) {
                        console.log("I had an error gettting loadTowjobsData" + err);
                    });
                    
                }, function (err) {
                    console.log("I had an error gettting Farms Data2" + err);
                });
                
                
            } else {
                getListOfStoragelots(argURL, argCompanyId, state.login.loginData.idToken, state.user.saveUserResp.id).then(function (companysList) {
                    
                    dispatch(loadStoragelotDataInStore(companysList));
                    
                }, function (err) {
                    console.log("I had an error gettting loadTowjobsData" + err);
                })
            }
            ;
        }//end of return
    }
}












function getArrayOfGetsForListOfStoragelots(argURL,argCompanyId ,argIdToken, argUserId  ){
    /*
     I build something like this :
     http://localhost:4567/company
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/storagelots";
    console.log(" on getting list of Storagelots  the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.get(baseUrl,{headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}

function getListOfStoragelots( argURL, argCompanyId ,argIdToken, argUserId ){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfGetsForListOfStoragelots(argURL, argCompanyId ,argIdToken, argUserId )).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on getting list of Storage " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}


/********************* End of InStore calls **************************/
//****************************************
//Add Storagelot to the Storagelots Array
//****************************************
export function addStoragelotToArray(argStoragelot ) {
    return (dispatch, getState) => {
        const state = getState();
        let tempStoragesArray=[] ;
        tempStoragesArray = Object.assign(tempStoragesArray,state.storagelot.storagelotsArray);
        let newStorageArray = tempStoragesArray.filter(element => { return element.id !== argStoragelot.id });
        //adding to the top of the array.
        newStorageArray.unshift(argStoragelot);
        //tempTowJobsArray.concat(argTowJob);
        dispatch(loadStoragelotDataInStore(newStorageArray));
    }//end of return
}

//****************************************
//Delete Storagelot from the Storagelots Array
//****************************************
export function deleteStoragelotFromStoragelotsArray(argStorageId ) {
    return (dispatch, getState) => {
        const state = getState();
        let tempStoragesArray=[] ;
        tempStoragesArray = Object.assign(tempStoragesArray,state.storagelot.storagelotsArray);
        //removig the match element with the matching id.
        let newArray = tempStoragesArray.filter(element => { return element.id != argStorageId });
        //tempTowJobsArray.concat(argTowJob);
        dispatch(loadStoragelotDataInStore(newArray));
    }//end of return
}
//****************************************
//update Storagelot in the Storagelots Array
//****************************************
export function updateStoragelotInStoragelotsArray(argStorage ) {
    return (dispatch, getState) => {
        const state = getState();
        let tempStoragesArray=[] ;
        tempStoragesArray = Object.assign(tempStoragesArray,state.storagelot.storagelotsArray);//storagelot.storagelotsArray);
        //rempoving the item from the array and then add the updated one to the array array.
        let newArray = tempStoragesArray.filter(element => { return element.id != argStorage.id });
        //adding to the top of the array.
        newArray.unshift(argStorage);
        //tempTowJobsArray.concat(argTowJob);
        dispatch(loadStoragelotDataInStore(newArray));
    }//end of return
}


/*
function getStoragelotsDataFromRemoteServer( argURL, argCompanysList  ){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if(argCompanysList != null){

            axios.all(getArrayOfGets(argURL, argCompanysList )).then(function(responses){
                resolve(responses);

            }, function(err) {
                console.log("Farshid some error occured " + err.message);
                reject(err);
            });
        }
    });

    return returnPromise;
}
*/

/*
function getArrayOfGets(argURL, argFarmsList ){

    //let baseUrl =  "http://innovasea-app-dev-1.eastus.cloudapp.azure.com:4567/METRIC_VALUES?";
    let baseUrl = argURL;


    var arrayOfGets = [];
    if(argFarmsList != null) {
        for (var i = 0; i < argFarmsList.length; i++) {
                let responseData = argFarmsList[i];
                //let responseData = singleResponse.data;
                //if((argMetricList[i].checked != null) && (argMetricList[i].checked == true) ) {
                let tempURl = baseUrl + "GRAPHS" + "/farm_summary?farmId=" + responseData.id;
                console.log("Farshid the Company DATA URL is =" + tempURl);
                arrayOfGets.push(axios.get(tempURl));

            //}
        }
    }
    return arrayOfGets;


}

*/

/*
export function loadCompanyData(argURL) {
    return (dispatch, getState) => {


        var arrayOfCompanyData=[];
        getListOfCompanys(argURL).then(function(companysList){

            for(var z=0; z<companysList.length; z++){

                let singleResponse = companysList[z];
                let responseData = singleResponse.data;
                getCompanyDataFromRemoteServer(argURL,responseData ).then(function (farmsData){
                    for(var i=0; i<farmsData.length; i++) {
                        arrayOfCompanyData.push(farmsData[i].data);
                    }
                    dispatch(loadCompanyDataInStore(arrayOfCompanyData));

                }, function (err){
                    console.log("I had an error gettting Farms Data3333" + err);
                });

            }
    }, function(err){
        console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}
 */

/*axios({
    method: "POST",
    url: serverUrl + "/multiplefiles",
    data: formData,
    headers: {
        "Content-Type": "multipart/form-data"
    }
}) */

/* This is example of axios

let img1 = yourFile1
let img2 = yourFile2
const formData = new FormData();
// It is of paramount importance for these to have the same name (the first paramater - here 'images')else multer will give you a very cryptic error
formData.append("images", img1);
formData.append("images", img2);
// you can of course append anything else you'd like
answerFormData.append("joke", "this is a poor mama joke");
axios({
    method: "POST",
    url: serverUrl + "/yourRoute",
    data: formData,
    headers: {
        "Content-Type": "multipart/form-data"
    }
})
    .then(response => {
            if (response.status === 200) {
                console.log("Success, firm added")
            } else {
                console.log("Error occurred")
            }
        }
    ).catch(e => {
    console.log(e)
})

 */
